angular.module('unergie.main')
.filter('readingNature', (BoFeaturesService) =>
    function (val) {
        switch (val) {
            case 'TRLV':
            case 'AUTO-RELEVE':
            case 'REEL':
            case 'ARLV': return 'RÉEL'
            case 'CAIF': return 'Estimé basé sur une relève réelle'
            case 'ESTI':
            case 'ESTIME':
            case 'CSIF':
            case 'FAC-REDRESS': return 'ESTIMÉ'
            default: return val
        }
    }
)
